'use client';

import { Component, type ReactNode } from 'react';

type BlockErrorBoundaryProps = {
  children: ReactNode;
  blockId: string;
  blockType: string;
};

type BlockErrorBoundaryState = {
  hasError: boolean;
};

export class BlockErrorBoundary extends Component<
  BlockErrorBoundaryProps,
  BlockErrorBoundaryState
> {
  state: BlockErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): BlockErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    const { blockId, blockType } = this.props;

    if (process.env.NODE_ENV === 'development') {
      console.error(`Block "${blockType}" (${blockId}) failed to render:`, error);
      return;
    }

    import('@sentry/nextjs').then((Sentry) => {
      Sentry.captureException(error, {
        tags: { blockId, blockType },
      });
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default BlockErrorBoundary;
